// action constants
export const SELECT_EQUIPMENT = 'SELECT_EQUIPMENT';
export const SELECT_SERVICES = 'SELECT_SERVICES';
export const SELECT_MENU_ITEM = 'SELECT_MENU_ITEM';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
